import React from 'react';
import 'react-phone-number-input/style.css';
import './PhoneWidget.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { useLanguage } from '../../../API/Context/LanguageContext';
import { VocabPhoneWidget as Vocab } from '../../../ConfigFiles/multilingual/VocabPhoneWidget';

interface PhoneWidgetProps {
  value?: string;
  onChange: (value?: string) => void;
}

const PhoneWidget: React.FC<PhoneWidgetProps> = ({ value, onChange }) => {
  const { t } = useLanguage();

  const isInvalid = Boolean(value && !isValidPhoneNumber(value));

  return (
    <div className="w-100 d-flex flex-column justify-content-center position-relative">
      <PhoneInput
        international
        defaultCountry="MX"
        placeholder={t(Vocab, 'number')}
        value={value || ''}
        onChange={onChange}
        className="custom-phone-wrapper"
        maxLength={16}
        smartCaret={false}
      />

      {isInvalid && (
        <div
          className="text-danger ps-2 position-absolute"
          style={{ fontSize: '9px', bottom: '-12px', fontWeight: 'bold' }}
        >
          {t(Vocab, 'incomplete_number')}
        </div>
      )}
    </div>
  );
};

export default PhoneWidget;